import { Alert, Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { PropsWithChildren } from 'react';
import { LoadingState } from '@shared/components/SystemStates';
import { useChannelVisibility } from './channelVisibility';
export function ChannelVisibilityBoundary({ children }: PropsWithChildren) {
  const visibility = useChannelVisibility();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  if (visibility.isPending) return <LoadingState />;
  // Retain the last confirmed configuration during a transient background refresh failure.
  if (visibility.isError && !visibility.data)
    return (
      <Box sx={{ p: 2 }}>
        <Alert
          severity="error"
          action={<Button onClick={() => void visibility.refetch()}>{t('common.retry')}</Button>}
        >
          {t('channelAdmin.loadError')}
        </Alert>
      </Box>
    );
  if (!visibility.pathVisible(pathname))
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">{t('channelAdmin.hiddenPage')}</Alert>
      </Box>
    );
  return children;
}
